import { useEffect } from "react";

export const useRemoveDomElements = ({
  ids, classNames
}: {
  ids: string[], classNames: string[]
}) => {
  const removeByClasses = (classNames: Array<string>) => {
    for (const className of classNames) {
      const elements = document.getElementsByClassName(className)
      if (elements.length > 0) {
        Array.from(elements).forEach((element) => {
          document.body.removeChild(element);
        });
      }
    }
  }
  const removeByIds = (ids: Array<string>) => {
    for (const id of ids) {
      const element = document.getElementById(id)
      if (element) {
        document.body.removeChild(element);
      }
    }
  }

  useEffect(() => {
    const observer = new MutationObserver(() => {
      removeByIds(ids);
      removeByClasses(classNames);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
    };
  }, [ids, classNames])

}
